import React from 'react';
import Pagination from './Pagination';
import { useRenderers } from '../../../../../renderProps';
const PaginationWithOverride = props => {
    const { Pagination: PaginationOverride = Pagination } = useRenderers();
    return React.createElement(PaginationOverride, Object.assign({}, props));
};
export default PaginationWithOverride;
